<template>
    <div>
        <component style="display: none" :is="show_document"></component>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>حواله های فروش</strong>
                            </CCol>
                            <CCol style="text-align: end;">
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        @click="print_with_header('print_report_buy','print_report_header','print_report_footer')"
                                        color="secondary"
                                >{{ $t("buttons.print") }}
                                </CButton>
                                <CButton @click="print_with_header()" size="sm" color="primary">
                                    {{ $t('components.referSelected') }}
                                </CButton>
                            </CCol>

                        </CRow>

                    </CCardHeader>
                    <div v-show="false">
                        <div id="print_report_header" class="border-dark">
                            <CCardHeader>
                                <CRow style="border: 1px solid #000">

                                    <CCol sm="4" md="4" style="text-align: right">
                                        <h2>{{ get_date(new Date()) }}</h2>
                                    </CCol>
                                    <CCol sm="4" md="4" style="text-align: center">
                                        <h2>لیست کالا های ارسالی</h2>

                                    </CCol>
                                    <CCol sm="4" md="4" style="text-align: left">
                                        <CImg :src="get_logo()" width="100px" height="50px"/>

                                    </CCol>
                                </CRow>

                            </CCardHeader>

                        </div>
                        <div id="print_report_footer" class="border-dark">
                            <CCardHeader>
                                <CRow style="border: 1px solid #000">
                                    <CCol sm="4" md="4" style="text-align: start">
                                        <h2>{{$t('docCreator')}} : {{ get_user_name() }}</h2>
                                    </CCol>
                                    <CCol sm="4" md="4" style="text-align: center">
                                        <h2 id="pageFooter" class="pageFooter"></h2>
                                    </CCol>
                                    <CCol sm="4" md="4" style="text-align: end">
                                        <h2>

                                        </h2>
                                    </CCol>
                                </CRow>

                            </CCardHeader>

                        </div>

                    </div>

                    <CCardBody id="print_report_buy">
                        <CRow>
                            <CCol col="3">
                                <date-picker

                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>

                        </CRow>
                        <CDataTable
                                :items="items_sell"
                                :fields="fields"
                                column-filter
                                @row-clicked="table_row_clicked"
                                :items-per-page="20"
                                hover
                                sorter
                                border
                                striped
                                :sorter-value="{column:'recId',asc:false}"
                                pagination
                        >
                            <template #row="{item}">
                                <td style="text-align: center">
                                    <p>{{ item.row_id + 1 }}</p>
                                </td>
                            </template>

                          <template  #status="{item}">
                            <td :class="get_style(item)" >
                              <p v-if="item.deliveryStatus==0">منتظر دریافت</p>
                              <p v-if="item.deliveryStatus==1">دریافت شده</p>
                              <p v-if="item.deliveryStatus==2">تحویل داده شده</p>
                            </td>
                          </template>
                            <template #createdAt="{item}">
                                <td>
                                    <p>{{ get_date(item.createdAt) }}</p>
                                </td>
                            </template>

                            <template #totalPrice="{item}">
                                <td>
                                    <p>{{ get_currency(item.totalPrice) }}</p>
                                </td>
                            </template>

                        </CDataTable>
                    </CCardBody>
                    {{$t('components.sendTempDocsProducts')}}
<CCardBody>
    <CDataTable
            :items="items_return"
            :fields="fields_return"
            column-filter
            @row-clicked="table_row_clicked"
            :items-per-page="20"
            hover
            sorter
            border
            striped
            :sorter-value="{column:'recId',asc:false}"
            pagination
    >
        <template #row="{item}">
            <td  style="text-align: center">
                <p>{{ item.row_id + 1 }}</p>
            </td>
        </template>
        <template #createdAt="{item}">
            <td>
                <p>{{ get_date(item.createdAt) }}</p>
            </td>
        </template>


        <template #totalPrice="{item}">
            <td>
                <p>{{ get_currency(item.totalPrice) }}</p>
            </td>
        </template>

    </CDataTable>

</CCardBody>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    const simulateAsyncOperation = fn => {
        setTimeout(fn, 200)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',


                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_driver: 0,
                driver_items: [],
                items_sell: [],
                items_return: [],
                table_clicks_timer: '',
                table_clicks: 0,

                fields: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'createdAt', label: this.$t('tables.date'), _style: 'width:15%'},

                    {key: 'masterFactorCode', label: this.$t('tables.number'), _style: 'width:2%'},
                    {key: 'supplierName', label: this.$t('supplier'), _style: 'width:10%'},
                    {key: 'partyName', label: this.$t('createdBy'), _style: 'width:10%'},
                    {key: 'status', label: this.$t('tables.status'), _style: 'width:10%'},

                    {key: 'totalPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
                ],

                fields_return: [
                    {key: 'row', label: this.$t('tables.sharp'), _style: 'width:2%'},
                    {key: 'productName', label: this.$t('tables.name'), _style: 'width:15%'},

                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:2%'},
                    // {key: 'supplierName', label: this.$t('supplier'), _style: 'width:10%'},
                    // {key: 'partyName', label: this.$t('createdBy'), _style: 'width:10%'},

                    // {key: 'totalPrice', label: this.$t('tables.totalAmount'), _style: 'width:10%'},
                ],

                status_form: 0,

            }
        }, mounted() {

            this.start_date = this.get_today();
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];
            this.get_all_data();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.person_id': function () {
                this.get_all_data();
            },
            'start_date': function () {
                this.get_all_data();
            },
            'end_date': function () {
                this.get_driver_lists();
            },
            'selected_driver': function () {
                this.get_all_data();

            }
        },
        methods: {
          get_style(item){
            if(item.deliveryStatus==0){
              return 'bg-warning';
            }
            if(item.deliveryStatus==1){
              return 'bg-primary';
            }
            if(item.deliveryStatus==2){
              return 'bg-success';
            }
          },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.goShowDocument(item)

                }

            },
          goShowDocument(item) {

            this.$router.push({path: '/dashboard/sale-orders/show_direct_sell_factor/' + item.masterId});
          },
            get_all_data() {
                this.get_lists_sell();
                this.get_lists_return();

            },

            get_lists_sell() {

                var self = this;


                const formData = new FormData();
                var url = "GetSuppFactors";
                // formData.append("SupplierId", localStorage.getItem('user_id'));
                formData.append("FirstDate", this.start_date);
                formData.append("SecondDate", this.end_date);
                formData.append("SupplierId", 0);
                axios.post(url, formData, {}).then(function (response) {
                    var content_data = response.data;
                    if (content_data.statusCode == 0) {
                        self.items_sell = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_lists_return() {

                var self = this;


                const formData = new FormData();
                var url = "GetRetSuppFactorProducts";
                // formData.append("SupplierId", localStorage.getItem('user_id'));
                formData.append("FirstDate", this.start_date);
                formData.append("SecondDate", this.end_date);
                formData.append("SupplierId", 0);
                axios.post(url, formData, {}).then(function (response) {
                    var content_data = response.data;
                    if (content_data.statusCode == 0) {
                        self.items_return = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },
            get_driver_lists() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetDistributorUsers', formData, {}).then(function (response) {

                    var content_data = response.data;
                    self.driver_items = [{label: 'انتخاب کنید', value: 0}]
                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.driver_items = self.sort_array(self.driver_items, content_data.data, 'personId', 'personName');
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


        },

    }

</script>
